import { ArticleContent } from 'src/types/articleCmsTypes';

const declOfNum = (number: number, titles: string[]) => {
  if (typeof number !== 'number' || titles?.length <= 0) return undefined;

  const cases = [2, 0, 1, 1, 1, 2];
  const result =
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5];

  return number + ` ${titles[result]}`;
};

export const getTimeToRead = (content: ArticleContent) => {
  if (!content) return undefined;
  let contentLength = 1;
  content.blocks.map((block) => {
    if (block.type === 'RichText') {
      contentLength += block.richText.length;
    }
  });

  const number = Math.ceil(contentLength / 1500);

  const arrayOfTitles = ['минута', 'минуты', 'минут'];
  const minutes = declOfNum(number, arrayOfTitles);
  return minutes;
};
